import {
  useEffect,
  type FunctionComponent,
} from "react";
import clsx from "clsx";
import type { StampType } from "~/database/stamps.model";
import {
  useFetcher,
  useNavigate,
} from "@remix-run/react";
import { useIsLogin } from "~/utils/hook/useIsLogin";
import toast from "react-hot-toast";

interface StampButtonProps {
  stamp: StampType;
  count: number;
  isStamp: boolean;
  postId: string;
}

const StampButton: FunctionComponent<
  StampButtonProps
> = ({ stamp, count, isStamp, postId }) => {
  const fetcher = useFetcher();
  useEffect(() => {
    console.log("fetcher:", fetcher);
  }, [fetcher]);
  const { isLogin } = useIsLogin();
  const nav = useNavigate();

  return (
    <button
      onClick={(e) => {
        if (isLogin) {
          fetcher.submit(
            {},
            {
              method: "post",
              action: `/posts/${postId}/stamps/${stamp.id}/add`,
            },
          );
        } else {
          toast.success("ログインが必要です", {
            duration: 4000,
            icon: "🔒",
          });
          nav("/login");
        }
        e.preventDefault();
      }}
      className={clsx(
        "flex",
        "items-center",
        "text-gray-400",
        "leading-[1]",
        "border",
        "border-gray-400",
        "rounded-sm",
        "px-8",
        "py-3",
        isStamp && "bg-gray-500",
        isStamp && "text-white",
        "justify-center",
        "max-md:w-110",
      )}
    >
      <div
        className={clsx(
          "text-20",
          "max-md:text-16",
        )}
      >
        {stamp.text}
      </div>
      <div
        className={clsx(
          "text-12",
          "ml-4",
          "max-md:text-10",
        )}
      >
        {stamp.name}
      </div>
      <div
        className={clsx(
          "text-15",
          "font-bold",
          "ml-6",
          "-mt-1",
          "max-md:text-13",
        )}
      >
        {count}
      </div>
    </button>
  );
};

export default StampButton;
